import {
  checkoutLoadBegin,
  checkoutLoadSuccess,
  checkoutLoadFailed,
  checkoutSaveBegin,
  checkoutSaveSuccess,
  checkoutSaveFailed,
} from "actions/checkoutActions";

const initialState = {
  checkoutResult: false,
  data: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case checkoutLoadBegin:
      return {
        ...state,
        fetching: true,
        saving: false,
        saved: false,
        fetched: false,
        error: null,
        checkoutResult: false,
      };

    case checkoutSaveBegin:
      return {
        ...state,
        saving: true,
        saved: false,
        fetching: false,
        error: null,
        checkoutResult: false,
      };

    case checkoutLoadFailed:
      return {
        ...state,
        fetching: false,
        fetched: false,
        saved: false,
        saving: false,
        error: action.payload,
      };

    case checkoutSaveFailed:
      return {
        ...state,
        saving: false,
        saved: false,
        fetching: false,
        error: action.payload,
      };

    case checkoutLoadSuccess:
      return {
        ...state,
        fetching: false,
        fetched: true,
        saved: false,
        saving: false,
        error: null,
        data: action.payload,
      };

    case checkoutSaveSuccess:
      return {
        ...state,
        saving: false,
        saved: true,
        error: null,
        checkoutResult: action.payload,
      };

    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./reducers/checkoutReducer.js